import React, { useState } from "react";
import DataTable from "react-data-table-component";

const AppDataTable = ({
    columns = [],
    data = [],
    paginationPerPage = 10,
    ...rest
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(paginationPerPage);

    // 🔢 Auto Serial Column
    const serialColumn = {
        name: "#",
        width: "70px",
        cell: (row, index) =>
            (currentPage - 1) * rowsPerPage + index + 1,
    };

    return (
        <DataTable
            columns={[serialColumn, ...columns]}
            data={data}
            pagination
            paginationPerPage={paginationPerPage}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRowsPerPage={(newPerPage, page) => {
                setRowsPerPage(newPerPage);
                setCurrentPage(page);
            }}
            highlightOnHover
            striped
            responsive
            {...rest}
        />
    );
};

export default AppDataTable;